<template>
  <div>
    <v-container
      style="width:60%; background-image:url('../../assets/head_bg.png');"
    >
      <v-row justify="center" align="center">
        <v-col cols="9">
          <a href="#/index"
            ><v-img
              max-height="100"
              max-width="480"
              src="../../assets/head.9175ab80.png"
            ></v-img></a
        ></v-col>
        <v-col cols="3">
          <input
            v-model="content"
            solo
            class="search-title"
            type="text"
            placeholder="搜索"
            @keyup.enter="goto()"
          />
          <!-- <v-text-field
            v-model="content"
            solo
            placeholder="回车搜索"
            @change="goto()"
          /> -->
        </v-col>
      </v-row>
    </v-container>

    <v-card>
      <v-tabs
        v-model="currentItem"
        centered
        slider-color="#3124aa"
        color="#3124aa"
      >
        <v-tab to="/index/">首页</v-tab>
        <v-menu
          offset-y
          open-on-hover
          v-for="(menu, index) in menuList"
          :key="index"
          transition="scroll-y-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-tab v-bind="attrs" v-on="on" :to="'/list/' + menu.menuId">
              {{ menu.menuName }}
            </v-tab>
          </template>

          <v-list v-if="menu.childTreeMenuList.length > 0">
            <v-list-item
              v-for="(item, index) in menu.childTreeMenuList"
              :key="index"
              :to="'/list/' + item.menuId"
            >
              <v-list-item-title>{{ item.menuName }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-tabs>

      <v-tabs-items style="background-color: #f9f9f9">
        <router-view :key="$route.fullPath" />
      </v-tabs-items>
    </v-card>

    <Footer />

    <back-to-top />
  </div>
</template>
<script>
export default {
  name: "PortalIndex2",
  components: {
    Footer: () => import("@/components/Footer"),
    BackToTop: () => import("@/components/BackToTop"),
  },
  data: () => ({
    currentItem: 0,
    menuList: [],
    content: "",
  }),
  methods: {
    click() {},
    getMenuList() {
      this.$api
        .getMenuList({})
        .then((res) => {
          this.menuList = res.data.data.slice(1);
        })
        .finally(() => {
          setTimeout(() => {
            // this.loading = false;
          }, 500);
        });
    },
    goto() {
      this.$router.push({
        path: "/search",
        query: { content: this.content, flag: true },
      });
    },
  },

  mounted() {
    this.getMenuList();
  },
};
</script>
<style>
.search-title {
  background: #fff;
  border: 0 none;
  color: #a0a0a0;
  font-size: 15px;
  height: 40px;
  line-height: 28px;
  outline: 2px solid #3124aa1c;
  padding: 0 0 0 11px;
  margin: 12% 0% 0% 18%;
  width: 100%;
  padding-left: 10%;
  border-radius: 25px;
}
</style>
